import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FormInput from '../../components/elements/form_input';
import Button from '../../components/elements/button';
import { Mail, Eye, EyeOff } from '../../assets/icons';
import psw from '../../assets/icons/password.svg';
import logo from '../../assets/icons/logo.svg';
import '../../assets/css/admin/login.css';
import { useAuth } from '../../context/AuthContext';

const AdminSignin = () => {
    const navigate = useNavigate();
    const { login, logout } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            const response = await login({
                email: formData.email,
                password: formData.password
            });

            // login() will throw if it fails, so if we get here we have a response
            const user = response.user || JSON.parse(localStorage.getItem('user'));
            if (!user?.is_admin) {
                setError('You are not authorized to access the admin portal');
                // clear any tokens that may have been stored
                logout();
                return;
            }

            // redirect to admin dashboard
            navigate('/admin/dashboard', { replace: true });
        } catch (err) {
            console.error('Admin login error:', err);
            setError('Invalid credentials');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-signin">
            <div className="signin-container">
                <div className="signin-form">
                    <div className="form-header">
                        <img src={logo} alt="E-AquaHealth" className="logo" />
                        <h1>Admin Portal</h1>
                        <p>Enter your credentials to access the admin dashboard</p>
                    </div>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <FormInput
                            label="Email Address"
                            type="email"
                            value={formData.email}
                            onChange={(e) => setFormData({
                                ...formData, 
                                email: e.target.value
                            })}
                            required
                            icon={<img src={Mail} alt='' />}
                            placeholder="admin@eaquahealth.com"
                        />

                        <div className="password-input">
                            <FormInput
                                label="Password"
                                type={showPassword ? 'text' : 'password'}
                                value={formData.password}
                                onChange={(e) => setFormData({
                                    ...formData,
                                    password: e.target.value
                                })}
                                required
                                icon={<img src={psw} alt='password' />}
                                placeholder="Enter your password"
                            />
                            <button 
                                type="button"
                                className="toggle-password"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <img src={EyeOff} alt="Hide password" /> : <img src={Eye} alt="Show password" />}
                            </button>
                        </div>

                        <Button
                            text={isLoading ? "Signing in..." : "Sign In"}
                            type="submit"
                            variant="primary"
                            fullWidth
                            loading={isLoading}
                            disabled={isLoading}
                        />
                    </form>

                    <div className="security-note">
                        <p>This is a secure area. Unauthorized access is prohibited.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSignin;